import { CommonState } from '../../typings/state';

export function resetSidebar(state: CommonState): CommonState {
    return {
        ...state,
        sidebar: {
            ...state.sidebar,
            selectedItemId: undefined,
            secondLevelMenuId: undefined,
            thirdLevelMenuId: undefined
        }
    };
}
